import actions from "../actions";

const BackdropReducer = (state = false, action) => {
  try {
    switch (action.type) {
      case actions.SHOW_BACKDROP:
        return true;

      case actions.HIDE_BACKDROP:
        return false;

      default:
        return state;
    }
  } catch (e) {}
};

export default BackdropReducer;
